import * as React from 'react';
import { loaderImages } from './LoaderImages';

export enum LoaderTheme {
     Dark = 'dark',
     Light = 'light',
}

export enum LoaderSize {
     UltraSmall = 'smallest',
     SuperSmall = 'smaller',
     Small = 'small',
     Medium = 'medium',
     Big = 'big',
}

interface LoaderProps {
     theme: LoaderTheme,
     size: LoaderSize
     position?: string
     appearWithFade?: boolean
     center?: boolean
     noMargin?: boolean
}

export class Loader extends React.PureComponent<LoaderProps> {
     render() {
          const { theme, size, position, appearWithFade, center, noMargin } = this.props;

          return <div className={`loader-wrapper ${size} ${position} ${appearWithFade && 'appear-with-fade'} ${center && 'in-center'} ${noMargin && 'no-margin'}`}>
               <img className="logo-state-1"
                    src={loaderImages[theme].logo1} />
               <img className="logo-state-2"
                    src={loaderImages[theme].logo2} />
               <img className="logo-state-3"
                    src={loaderImages[theme].logo3} />
               <img className="logo-state-4"
                    src={loaderImages[theme].logo4} />
               <img className="logo-state-5"
                    src={loaderImages[theme].logo5} />
               <img className="logo-state-6"
                    src={loaderImages[theme].logo6} />
               <img className="logo-state-7"
                    src={loaderImages[theme].logo7} />
               <img className="logo-state-8"
                    src={loaderImages[theme].logo8} />
               <img className="logo-state-9"
                    src={loaderImages[theme].logo9} />
               <img className="logo-state-10"
                    src={loaderImages[theme].logo10} />
          </div>;
     }
}